<template>
  <dropdown-notification v-cloak>
    <div @click="verOrdenesTrabajo" slot="fa-icon">
      <i class="fa fa-first-order" aria-hidden="true"></i>
      <span class="badge-warning" id="ordenesTrabajo">{{ ordenesTrabajo }}</span>
    </div>
  </dropdown-notification>
</template>

<script>
export default {
  data: function() {
    return {
      ordenesTrabajo: 0
    };
  },
  methods: {
    cargarOrdenesTrabajo: function() {
      let that = this;
      axios.get(url + "/notificaciones-orden-trabajo").then(function(response) {
        that.ordenesTrabajo = response.data.ordenesTrabajo;
      });
    },
    verOrdenesTrabajo: function() {
      window.open(url + "/notificaciones-orden-trabajo", "_blank");
    }
  },
  mounted: function() {
    this.cargarOrdenesTrabajo();
    setInterval(this.ordenesTrabajo, 1000 * 60);
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/element/NotificacionesOt.vue